import {constants} from "../constants";

export const environment = {
  production: true,
  name: constants.SYNNEX_Public,
  env: "Prod",
  appBaseUrl: "",
  standaloneAppBaseUrl: "https://chromeos-selector-synnex-public-prod.web.app/",
  productInfoPageBaseUrl: "",
  firebaseConfigParam: "synnex_public_enterprise_config",
  notYourIndustryLinkUrl: "",
  firebaseUserEmail: "firebase-adminsdk-my5pg@chromebook-selector-nsit-prod.iam.gserviceaccount.com",
  firebase: {
    apiKey: "AIzaSyA91zyZT9pehX9j66qVQ21MOH3txErbw1U",
    authDomain: "chromebook-selector-nsit-prod.firebaseapp.com",
    projectId: "chromebook-selector-nsit-prod",
    storageBucket: "chromebook-selector-nsit-prod.appspot.com",
    messagingSenderId: "774770955470",
    appId: "1:774770955470:web:d3761d86ca3a3f16d36c9f",
    measurementId: "G-Q4GKQCPGJ5"
  }
};
